$shm_hitalama_taskmanager $mol_book2
	plugins /
		<= Theme $mol_theme_auto
	pages /
		<= Todo $shm_hitalama_taskmanager_column
			title \Todo
			status \todo
			tasks? <=> tasks_by_status*todo? /
			task*? <=> task*? null
			task_add? <=> task_add? null
		<= Progress $shm_hitalama_taskmanager_column
			title \In progress
			status \progress
			tasks? <=> tasks_by_status*progress? /
			task*? <=> task*? null
		<= Done $shm_hitalama_taskmanager_column
			title \Done
			status \done
			tasks? <=> tasks_by_status*done? /
			task*? <=> task*? null
